import React, {Component} from 'react';
import PropTypes from 'prop-types';
// utils
import classnames from 'classnames';
import renderSvg from '~/utils/renderInlineSvg';
// constants
import {closeIcon} from '~/constants/InlineSvgs';
import {speed} from '~/constants/Animations';
// components
import {VelocityComponent} from 'velocity-react';
import {Typography} from '@customink/pigment-react';

import './DetailsToggle.scss';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  defaultExpanded: PropTypes.bool,
  title: PropTypes.string,
  onChange: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */

export default class DetailsToggle extends Component {
  static propTypes = propTypes;
  static defaultProps = {
    onChange() {}
  };

  state = {
    expanded: true,
    animating: false
  };

  UNSAFE_componentWillMount() {
    this.setState({expanded: this.props.defaultExpanded});
  }

  contentRef = node => {
    if (node) {
      const {height} = node.getBoundingClientRect();
      this.contentHeight = height;
    }
    this.contentNode = node;
  };

  computeHeight() {
    return this.state.expanded ? this.contentHeight : 0;
  }

  handleClick = () => {
    if (!this.state.expanded) {
      const {height} = this.contentNode.getBoundingClientRect();
      this.contentHeight = height;
    }
    this.setState(prevState => {
      const expanded = !prevState.expanded;
      this.props.onChange({expanded});
      return {expanded, animating: true};
    });
  };

  handleDone = () => {
    this.setState({animating: false});
  };

  render() {
    return (
      <section
        className={classnames('ndx-DetailToggle', this.props.className)}
        data-testid="DetailsToggle">
        <div
          className="ndx-DetailToggle-toggleContainer"
          onClick={this.handleClick}>
          <Typography variant="heading4">{this.props.title}</Typography>
          <span
            className={classnames('ndx-DetailToggle-toggle u-p4', {
              'ndx-DetailToggle-toggle--expanded': this.state.expanded
            })}
            data-testid="DetailsToggleExpand"
            dangerouslySetInnerHTML={renderSvg(closeIcon)}
          />
        </div>
        <VelocityComponent
          animation={{minHeight: this.computeHeight()}}
          complete={this.handleDone}
          duration={speed.default}>
          <Typography
            component="div"
            variant="uiTextDefault"
            className="ndx-DetailToggle-contentWrapper">
            <div
              ref={this.contentRef}
              className={classnames(
                'ndx-DetailToggle-content',
                {
                  'ndx-DetailToggle-content--static':
                    !this.state.animating && this.state.expanded
                },
                {[`${this.props.className}-content`]: this.props.className}
              )}
              data-testid="DetailsToggleContent">
              {this.props.children}
            </div>
          </Typography>
        </VelocityComponent>
      </section>
    );
  }
}
